import ApiService from './ApiService'
import appConfig from 'configs/app.config'

export async function getCityDataList(data) {
    return ApiService.fetchData({
        url: appConfig.baseUrl + '/admin/api/city/?search_term=' + data,
        method: 'get',
        data,
    })
}
export async function getCountryList(data) {
    return ApiService.fetchData({
        url:
            appConfig.baseUrl + '/admin/api/city/countries?search_term=' + data,
        method: 'get',
        data,
    })
}
export async function getStateList(input, country_id) {
    return ApiService.fetchData({
        url:
            appConfig.baseUrl +
            `/admin/api/city/states?country_id=${country_id}&search_term=` +
            input,
        method: 'get',
        input,
    })
}
export async function getCategoryList(data) {
    return ApiService.fetchData({
        url: appConfig.baseUrl + '/admin/api/category/',
        method: 'get',
        data,
    })
}
export async function createCity(data) {
    return ApiService.fetchData({
        url: appConfig.baseUrl + '/admin/api/city/',
        method: 'post',
        data,
    })
}
